import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { appThemeColors } from "styles/appTheme";
import { appThemeFonts } from "styles/appThemeFonts";
import { FieldWrapper } from "styles/formStyleComponents";

const uiFont = appThemeFonts.family.ui;

export const ErrorText = styled(Typography)(() => ({
  marginBottom: 0,
  fontFamily: uiFont,
  fontSize: "12.5px",
  color: appThemeColors.semantic.danger,
}));

export const DrawerNote = styled(Typography)({
  fontFamily: uiFont,
  fontSize: "12.5px",
  fontWeight: 400,
  color: appThemeColors.text.muted,
  margin: 0,
  lineHeight: 1.55,
  borderTop: `1px solid ${appThemeColors.border.default}`,
  paddingTop: 14,
});

export const FieldsStack = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 15,
  "& > *": {
    marginBottom: "0 !important",
  },
  [`& ${FieldWrapper}`]: {
    marginBottom: 0,
  },
});

export const FieldLabel = styled(Typography)({
  display: "block",
  fontFamily: uiFont,
  fontSize: 12,
  fontWeight: 600,
  color: appThemeColors.text.primary,
  marginBottom: 6,
  lineHeight: 1.3,
});

export const ReadOnlyValue = styled(Typography)({
  display: "flex",
  alignItems: "center",
  minHeight: 38,
  padding: "0 12px",
  boxSizing: "border-box",
  borderRadius: 9,
  border: `1px solid ${appThemeColors.border.default}`,
  backgroundColor: appThemeColors.background.fill,
  fontFamily: uiFont,
  fontSize: "13.5px",
  color: appThemeColors.text.muted,
  lineHeight: 1.35,
});
